import { render } from "./DobleChar.vue?vue&type=template&id=35ecccd4"
import script from "./DobleChar.vue?vue&type=script&lang=js"
export * from "./DobleChar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__